import { render, staticRenderFns } from "./ModalOtp.vue?vue&type=template&id=5664893f&"
import script from "./ModalOtp.vue?vue&type=script&lang=js&"
export * from "./ModalOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports